import { FC } from 'react'

import LinkPreviewWrapper from '../GeneralLinkPreview/components/LinkPreviewWrapper'

type FullImagePreviewProps = {
  url?: string | null
  image: string
}

const FullImagePreview: FC<FullImagePreviewProps> = ({ image, url }) => (
  <LinkPreviewWrapper
    className="flex w-full max-w-full cursor-pointer"
    url={url}
  >
    <img data-testid="full-image-preview" src={image} alt="link preview" />
  </LinkPreviewWrapper>
)

export default FullImagePreview
